'use strict';

exports.__esModule = true;

var _reactRouter = require('react-router');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _reactRouter.withRouter;
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/react-router-dom/withRouter.js
// module id = ./node_modules/react-router-dom/withRouter.js
// module chunks = 0